module.exports = __webpack_public_path__ + "img/logo-dark.679ea879.png";